<div class="dialog-header-container d-flex align-items-center justify-content-between p-3 border-bottom bg-white">

  @if(toggleRemorque.checked){
      @if(inputData.update){
        <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">Modifier la remorque : {{inputData.title}}</h2>
      }@else {
        <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">Ajouter une remorque</h2>
      }
  }@else {
    @if(inputData.update){
      <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">Modifier le vehicule {{ inputData.title }}</h2>
    }@else {
      <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">Ajouter le vehicule {{ inputData.title }}</h2>
    }

  }
  <button mat-icon-button mat-dialog-close (click)="resetForm()" aria-label="Fermer">
    <mat-icon class="text-muted">close</mat-icon>
  </button>
</div>

<mat-dialog-content [formGroup]="vehiculeForm" class="p-4 bg-white custom-dialog-content">

  <div class="row g-3">

    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Immatriculation</mat-label>
        <input
          matInput
          type="text"
          #inputI
          (blur)="checkValue('immatriculation', inputI.value, 'immatriculation')"
          formControlName="immatriculation"
          placeholder="Entrez l'immatriculation du véhicule">
        @if (vehiculeForm.get('immatriculation')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        @if (vehiculeForm.get('immatriculation')?.hasError('exist')) {<mat-error>Cette immatriculation est déjà utilisée</mat-error>}
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Numéro du châssis</mat-label>
        <input
          matInput
          type="text"
          #inputC
          (blur)="checkValue('chassis', inputC.value, 'chassis')"
          formControlName="chassis"
          placeholder="Entrez l'immatriculation du véhicule">
        @if (vehiculeForm.get('chassis')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        @if (vehiculeForm.get('chassis')?.hasError('exist')) {<mat-error>ce châssis est déjà utilisé</mat-error>}
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Marque</mat-label>
        <input
          matInput
          type="text"
          formControlName="marque"
          [matAutocomplete]="autoMarque"
          #inputM
          placeholder="Entrez la marque du véhicule">
        <mat-autocomplete (closed)="loadModel(inputM.value!)" autoActiveFirstOption #autoMarque="matAutocomplete">
          @for (item of marques(); track $index) {
            <mat-option [value]="item?.name_marque">{{ item?.name_marque }}</mat-option>
          }
        </mat-autocomplete>
        @if (vehiculeForm.get('marque')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Modèle</mat-label>
        <input
          matInput
          type="text"
          formControlName="model"
          [matAutocomplete]="autoModel"
          placeholder="Entrez le modèle du véhicule">
        <mat-autocomplete #autoModel="matAutocomplete">
          @for (item of models(); track $index) {
            <mat-option [value]="item">{{ item }}</mat-option>
          }
        </mat-autocomplete>
        @if (vehiculeForm.get('model')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-4 d-flex align-items-center justify-content-start justify-content-sm-center pt-2 pt-sm-0">
      <mat-slide-toggle formControlName="remorque" labelPosition="before" #toggleRemorque class="custom-toggle">
        <span class="text-secondary small fw-medium">{{ toggleRemorque.checked ? 'Remorque : OUI' : 'Remorque : NON' }}</span>
      </mat-slide-toggle>
    </div>

    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Genre</mat-label>
        <input
          matInput
          type="text"
          formControlName="genre"
          [matAutocomplete]="genre"
          [value]="toggleRemorque.checked?'REMORQUE':''"
          placeholder="Entrez genre du véhicule">
        <mat-autocomplete #genre="matAutocomplete">
          @for (item of genresFiltered; track $index) {
            <mat-option [value]="item">{{ item }}</mat-option>
          }
        </mat-autocomplete>
        @if (vehiculeForm.get('genre')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6">
      <div class="row g-2">
        <div class="col-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Puissance (CV)</mat-label>
            <input
              matInput
              type="number"
              [readonly]="toggleRemorque.checked"
              formControlName="puissance"
              placeholder="Puissance du véhicule">
            @if (vehiculeForm.get('puissance')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
            @if (vehiculeForm.get('puissance')?.hasError('min')) {<mat-error>puissance supérieure à 0</mat-error>}
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Cylindrée (CM3)</mat-label>
            <input
              matInput
              type="number"
              [readonly]="toggleRemorque.checked"
              formControlName="cylindree"
              placeholder="">
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Énergie</mat-label>
        <mat-select formControlName="energie" [disabled]="toggleRemorque.checked">
          @for (item of energies; track $index) {
            <mat-option [value]="item">{{ item }}</mat-option>
          }
        </mat-select>
        @if (vehiculeForm.get('energie')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Date de circulation</mat-label>
        <input
          matInput
          formControlName="date_circulation"
          [matDatepicker]="pickerDate"
          placeholder="JJ/MM/AAAA"
          appDateMask>
        <mat-datepicker-toggle matIconSuffix [for]="pickerDate"></mat-datepicker-toggle>
        <mat-datepicker #pickerDate></mat-datepicker>
        @if (vehiculeForm.get('date_circulation')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Place</mat-label>
        <input
          matInput
          type="number"
          [readonly]="toggleRemorque.checked"
          formControlName="place"
          placeholder="Nombre de places">
        @if (vehiculeForm.get('place')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        @if (vehiculeForm.get('place')?.hasError('min')) {<mat-error>au moins une place</mat-error>}
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Charge à vide</mat-label>
        <input
          matInput
          type="number"
          formControlName="charge_vide"
          placeholder="Poids à vide (kg)">
        @if (vehiculeForm.get('charge_vide')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        @if (vehiculeForm.get('charge_vide')?.hasError('min')) {<mat-error>au moins 1kg</mat-error>}
      </mat-form-field>
    </div>

    <div class="col-12 col-sm-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Charge utile</mat-label>
        <input
          matInput
          type="number"
          formControlName="charge_utile"
          placeholder="Charge utile (kg)">
        @if (vehiculeForm.get('charge_utile')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        @if (vehiculeForm.get('charge_utile')?.hasError('min')) {<mat-error>au moins 1kg</mat-error>}
      </mat-form-field>
    </div>

  </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top bg-light m-0 gap-2">
  <button mat-stroked-button mat-dialog-close cdkFocusInitial color="warn" class="px-4" (click)="resetForm()">Fermer</button>

  @if (inputData.update) {
    <button [disabled]="loadingbtn() || vehiculeForm.invalid" mat-flat-button color="primary" class="px-4 spinner-btn" (click)="onUpdate()">
      <span>Modifier</span>
      @if (loadingbtn()) {<mat-spinner diameter="16" class="ms-2"></mat-spinner>}
    </button>
  } @else {
    <button [disabled]="loadingbtn() || vehiculeForm.invalid" mat-flat-button color="primary" class="px-4 spinner-btn" (click)="onAdd()">
      <span>Enregistrer</span>
      @if (loadingbtn()) {<mat-spinner diameter="16" class="ms-2"></mat-spinner>}
    </button>
  }
</mat-dialog-actions>
